import {view, Icon, IconProps} from '@sail/ui';
import type {IconAsset} from '@sail/icons/types';

import * as BrandIcons from '@sail/icons/react/BrandIcon';
import * as CardIcons from '@sail/icons/react/CardIcon';
import * as PaymentMethodIcons from '@sail/icons/react/PaymentMethodIcon';

const BankAccountIcon = ({
  iconName = 'bank',
}: Omit<IconProps, 'icon'> & {
  iconName: string | undefined;
}) => {
  let icon: IconAsset | undefined;

  if (iconName in BrandIcons) {
    icon = BrandIcons[iconName as keyof typeof BrandIcons];
  } else if (iconName in CardIcons) {
    icon = CardIcons[iconName as keyof typeof CardIcons];
  } else if (iconName in PaymentMethodIcons) {
    icon = PaymentMethodIcons[iconName as keyof typeof PaymentMethodIcons];
  } else {
    // We always fallback to "bank" if we could not resolve iconName to an icon.
    // Banks are the most common type, or at least we expect it to be the most common way it
    // would not resolve (cards for ex have a much smaller and more stable set of potential values).
    icon = BrandIcons.bank;
  }

  if (icon) {
    return <Icon icon={icon} size="medium" />;
  }

  return null;
};

export const BankAccountWithIcon = ({
  iconName,
  accountName,
}: {
  iconName?: string;
  accountName?: string;
}) => {
  return (
    <view.div
      css={{stack: 'x', gap: 'xsmall', alignY: 'center', alignX: 'start'}}
    >
      <BankAccountIcon data-testid="bank-account-icon" iconName={iconName} />
      <view.span data-testid="bank-account-name">{accountName || ''}</view.span>
    </view.div>
  );
};
